module.exports = __webpack_public_path__ + "img/gemc.4d172b01.png";